/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';

import Grid from '../../../../../../lib/clear-bi/grid/components/Grid';

const useStyles = makeStyles(() => ({
  grid: {
    height: '89vh',
    overflow: 'hidden'
  },
}));

const CodeMappingGrid = ({
  keyGrid,
  columns,
  data,
  options,
  localization,
  actions,
  isLoading,
  detailPanel
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.grid}
        title="Code Mapping"
        keyGrid={keyGrid}
        columns={columns}
        data={data}
        options={options}
        actions={actions}
        localization={localization}
        isLoading={isLoading}
        detailPanel={detailPanel}
      />
    </>
  );
};

CodeMappingGrid.propTypes = {
  keyGrid: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  options: PropTypes.object.isRequired,
  actions: PropTypes.array,
  localization: PropTypes.object,
  isLoading: PropTypes.bool,
  detailPanel: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.array
  ])
};

CodeMappingGrid.defaultProps = {
  localization: {},
  data: [],
  isLoading: false,
  actions: [],
  detailPanel: null
};

export default CodeMappingGrid;
